import moment from "moment";
import {AgGridVue} from "ag-grid-vue";
import vSelect from "vue-select";
import Datepicker from "vuejs-datepicker";
import {en, es} from "vuejs-datepicker/src/locale";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import moduleOptimization from "@/store/optimization/moduleOptimization.js";
import DateUtils from "@/helpers/DateUtils.js";
import Api from "@/helpers/api.js";

export const ScheduleWaypointsListMixin = {
	name: "ScheduleWaypointsList",
	props: {
		waypointList: {
			type: Array,
			default: () => [],
		},
		dataFilter: {
			type: Object,
			default: () => {},
		},
	},
	components: {
		AgGridVue,
		vSelect,
		Datepicker,
	},
	data() {
		return {
			searchQuery: [],
			resourceList: [],
			currentPageLocal: 1,
			quantityElementPage: 12,
			gridApi: null,
			langEs: es,
			langEn: en,
			gridOptions: {},
			init_date: new Date(),
			end_date: new Date(),
			searchField: [{value: "date", label: this.$t("ManualData.date"), disabled: true}],
			selectedResource: {label: this.$t("Select"), value: null},
			pagination: {
				next_page: 0,
				total_pages: 0,
				total_records: 0,
			},
			defaultColDef: {
				sortable: true,
				resizable: true,
				suppressMenu: true,
			},
		};
	},
	watch: {
		currentPageLocal(page) {
			this.getEventList(page);
		},
		quantityElementPage() {
			this.getEventList(1);
		},
		searchField(newValue, oldValue) {
			if (newValue.length < oldValue.length) {
				const disabledOptionValue = this.searchOptions.find((opt) => opt.disabled);
				if (disabledOptionValue && !newValue.includes(disabledOptionValue)) {
					const newSearchField = [...newValue];
					newSearchField.unshift(disabledOptionValue);
					this.searchField = newSearchField;
					delete this.searchField[1];
				} else {
					this.searchField = newValue;
				}
			}
		},
	},
	created() {
		if (!moduleOptimization.isRegistered) {
			this.$store.registerModule("moduleOptimization", moduleOptimization);
			moduleOptimization.isRegistered = true;
		}
	},
	async mounted() {
		this.gridApi = this.gridOptions.api;
		if (this.dataFilter.date_init && this.dataFilter.date_end) {
			this.init_date = moment(this.dataFilter.date_init).format();
			this.end_date = moment(this.dataFilter.date_end).format();
		}
		this.getEventList(1);
		this.getVehiclesDatarutas(1);
	},
	computed: {
		windowWidth() {
			return this.$store.state.windowWidth;
		},
		isWidthPortatil() {
			return window.innerWidth <= 1366;
		},
		overlayLoadingTemplate() {
			return `<div class="ring">${this.$t("Loading")}<span></span></div>`;
		},
		overlayNoRowsTemplate() {
			return `<span style="font-size: 14px; font-weight: 500; color: grey">${this.$t("NoDataAvailable")}</span>`;
		},
		columnDefs() {
			let filterHead = undefined;
			let columns = [
				{
					headerName: "ID",
					field: "id",
					width: 170,
					filter: filterHead,
					headerCheckboxSelectionFilteredOnly: false,
					cellRendererFramework: null,
					checkboxSelection: true,
					headerCheckboxSelection: false,
					pinned: "left",
				},
				{
					headerName: this.$t("Routing.Table.AddedOn"),
					field: "date_prog",
					filter: filterHead,
					width: 140,
				},
				{
					headerName: this.$t("BreakTable.StartHour"),
					field: "init_hour",
					filter: filterHead,
					width: 150,
				},
				{
					headerName: this.$t("Resource"),
					field: "resource_id",
					filter: filterHead,
					width: 450,
					valueGetter: (params) => {
						const resource = params.data.resource_id || "";
						const name = params.data.username || "";
						return `${resource} - ${name}`;
					},
				},
				{
					headerName: this.$t("VisitPoint"),
					field: "visit_point_identification",
					filter: filterHead,
					width: 450,
					valueGetter: (params) => {
						const visitPoint = params.data.visit_point_identification || "";
						const name = params.data.visit_point_name || "";
						return `${visitPoint} - ${name}`;
					},
				},
				{
					headerName: this.$t("Address"),
					field: "address",
					filter: filterHead,
					width: 250,
				},
				{
					headerName: this.$t("Divipola.Department"),
					field: "department",
					filter: filterHead,
					width: 200,
				},
				{
					headerName: this.$t("Divipola.City"),
					field: "city",
					filter: filterHead,
					width: 200,
				},
				{
					headerName: this.$t("Divipola.Country"),
					field: "country",
					filter: filterHead,
					width: 200,
				},
			];
			const showColumns = [];
			if (showColumns.length > 0) {
				columns = columns.filter((column) => {
					if (showColumns.includes(column.field)) {
						return column;
					}
				});
			}
			return columns;
		},
		paginationPageSize() {
			if (this.pagination.total_records > 0) {
				return this.pagination.total_records;
			} else {
				return 0;
			}
		},
		totalPages() {
			if (this.pagination.total_pages > 0) return this.pagination.total_pages;
			else return 0;
		},
		currentPage: {
			get() {
				return this.currentPageLocal;
			},
			set(val) {
				this.currentPageLocal = val;
			},
		},
		eventsData() {
			return this.$store.state.moduleOptimization.eventList === undefined ||
				this.$store.state.moduleOptimization.eventList === "" ||
				this.$store.state.moduleOptimization.eventList === null
				? []
				: this.$store.state.moduleOptimization.eventList;
		},
		getCheckedEvents() {
			return this.$store.state.moduleOptimization.checkedEvents;
		},
		resourceOptions() {
			return this.resourceList.map((resource) => {
				return {
					value: resource.id,
					label: resource.id + " - " + resource.name + " " + resource.lastname,
				};
			});
		},
		searchOptions() {
			return [
				{value: "date", label: this.$t("ManualData.date"), disabled: true},
				{value: "resource", label: this.$t("Resource")},
			];
		},
		disabledDatesTo() {
			return {to: new Date(this.init_date)};
		},
	},
	methods: {
		getEventList(page) {
			this.onBtShowLoading();
			const payload = {
				sort: "DESC",
				page,
				quantity: this.quantityElementPage,
				event_status_id: [1, 2],
				init_date: DateUtils.toDefaultDateTime(this.init_date, "YYYY-MM-DD"),
				end_date: DateUtils.toDefaultDateTime(this.end_date, "YYYY-MM-DD"),
			};
			const includesResource = this.searchField.some((item) => item.value === "resource");
			if (includesResource && this.selectedResource) payload.resource_id = [this.selectedResource.value];
			this.$store
				.dispatch("moduleOptimization/fetchEventsWaypointsList", payload)
				.then((res) => {
					Object.assign(this.pagination, res.pagination);
					setTimeout(() => {
						this.resetColFilters();
					}, 100);
					this.onBtHide();
				})
				.catch((err) => {
					this.onBtHide();
					console.error(err);
				});
		},
		resetColFilters() {
			this.gridApi.setFilterModel(null);
			this.gridApi.onFilterChanged();
		},
		paginationSetPageSize(num) {
			this.gridApi.paginationSetPageSize(num);
			this.quantityElementPage = num;
		},
		refresh() {
			this.searchQuery = [];
			this.getEventList(1);
		},
		onBtShowLoading() {
			this.gridApi.showLoadingOverlay();
		},
		onBtHide() {
			this.gridApi.hideOverlay();
		},
		rowSelected(event) {
			const isSelected = event.node.isSelected();
			if (isSelected) {
				this.$store.commit("moduleOptimization/ADD_EVENTS_WAYPOINTS_CHECKED", event.data);
			} else {
				this.$store.commit("moduleOptimization/REMOVE_EVENTS_WAYPOINTS_CHECKED", event.data);
			}
		},
		async scheduleWhitWaypoint() {
			this.showLoadingPopup();
			const payload = {
				event_id: this.getCheckedEvents[0].id,
				waypoints: this.waypointList,
			};
			await Api.post("/datarutas/create_waypoints", payload)
				.then((res) => {
					this.handleRouterSuccess(res.data.waypoints);
					this.$vs.loading.close("#schedule-loading-waypoints > .con-vs-loading");
					return res;
				})
				.catch((err) => {
					this.handleApiError();
					this.$vs.loading.close("#schedule-loading-waypoints > .con-vs-loading");
					return err;
				});
		},
		handleRouterSuccess(data) {
			this.$emit("closePopupWaypointEmit");
			this.$vs.notify({
				color: "success",
				title: this.$t("Schedule"),
				text: `${data.length} ${this.$t("Routing.Map.Schedule.Success")}`,
				time: 5000,
			});
			this.$store.commit("moduleOptimization/REMOVE_ALL_EVENTS_WAYPOINTS");
		},
		async handleApiError() {
			this.$vs.notify({
				color: "warning",
				title: this.$t("Schedule"),
				text: this.$t("Routing.Map.Schedule.FoundErrors"),
				time: 5000,
			});
		},
		async getVehiclesDatarutas(page) {
			const payload = {
				page,
				role_name: ["EXECUTIVE", "SUPERVISOR"],
				match_filter: !this.isExactly,
				sort: "desc",
				order_by: ["id"],
			};
			await this.$store
				.dispatch("vehicle/fetchDatarutasResource", payload)
				.then((res) => {
					this.resourceList = res.records;
					if (this.dataFilter.resource_id) {
						this.searchField.push({value: "resource", label: this.$t("Resource")});
						const filterResource = this.resourceList.filter(
							(data) => data.id === this.dataFilter.resource_id
						);
						this.selectedResource = {
							label:
								filterResource[0].id +
								" - " +
								filterResource[0].name +
								" " +
								filterResource[0].lastname,
							value: filterResource[0].id,
						};
					}
				})
				.catch((err) => {
					console.error(err);
				});
		},
		showLoadingPopup() {
			this.$vs.loading({
				container: "#schedule-loading-waypoints",
				text: this.$t("Routing.Map.Schedule.WeAreGeneratingTheSchedule"),
			});
		},
	},
	beforeDestroy() {
		this.$store.commit("moduleOptimization/REMOVE_ALL_EVENTS_WAYPOINTS");
	},
};
